export const formatDate = (rawDate: Date) => {
  // return processed value
  return (
    rawDate.getDate().toString().padStart(2, '0') +
    '.' +
    (rawDate.getMonth() + 1).toString().padStart(2, '0') +
    '.' +
    rawDate.getFullYear()
  )
}

/**
 * Filter every number separator from given string,
 * keeps last one and converts it into decimal separator
 *
 * Example: "123.45,67" to "12345.67" for GBP
 */
export const filterUserPriceInput = (input: string): string => {
  if (!input) return input

  return input
    ?.toString()
    .replace(/,/g, '.') // convert all commas to points
    .replace(/[.](?=.*[.])/g, '') // remove all point except last
}
